var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video-container"},[_c('h1',{staticClass:"text--center my-3"},[_vm._v("How Guiomentor can help you?")]),_c('youtube-media',{attrs:{"player-width":_vm.$vuetify.breakpoint.xs ? null : 800,"video-id":_vm.videoId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }